import { Box, Button, Flex, IconButton, Text } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { VscDebugConsole } from 'react-icons/vsc';
import useDebugModeContext from '../../../hooks/useDebugModeContext';
const DebugModeBotton: FC = () => {
  const [displayConsole, setDisplayConsole] = useState(false);
  const debugCtx = useDebugModeContext();
  return (
    <Box position={'absolute'} top={0} left={0} zIndex={9999}>
      <IconButton colorPalette={'red'} onClick={() => setDisplayConsole(!displayConsole)}>
        <VscDebugConsole />
      </IconButton>
      {displayConsole && (
        <Box background={'white'}>
          <Flex>
            <Button colorPalette={'blue'} onClick={() => debugCtx.toggleRecordingPreview()}>
              {debugCtx.recordingPreview ? '録画プレビューOFF' : '録画プレビューON'}
            </Button>
          </Flex>
          <Box width={'100vw'} height={'200px'} padding={'3px'} overflow={'scroll'} background={'gray'}>
            <Box background={'white'}>
              {debugCtx.message.map((e, index) => (
                <Text key={index} textAlign={'left'}>
                  {e}
                </Text>
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DebugModeBotton;
